import { Heart } from "lucide-react";
import { scrollToId } from "../lib/scroll";

export const Logo = ({ light = false }) => (
  <button
    data-testid="brand-logo"
    onClick={() => scrollToId("#top")}
    className="group flex items-end pb-0.5 leading-none"
    aria-label="Mi Binky — back to top"
  >
    <span className="font-display text-[28px] font-extrabold tracking-tight text-binky-pink">B</span>
    <span className="relative font-display text-[28px] font-extrabold tracking-tight text-binky-pink">
      <Heart className="absolute -top-[7px] left-1/2 h-[11px] w-[11px] -translate-x-1/2 fill-binky-pink text-binky-pink transition-transform duration-300 group-hover:scale-125" />
      ı
    </span>
    <span
      className={`font-display text-[28px] font-extrabold tracking-tight ${
        light ? "text-white" : "text-binky-blue"
      }`}
    >
      NKY
    </span>
    <span className={`mb-3 ml-0.5 text-[9px] font-bold ${light ? "text-white/60" : "text-binky-blue/50"}`}>
      TM
    </span>
  </button>
);
